<template>
	<div class="app_article" v-loading="loading">
		<!-- 类型 -->
		<side-types 
			:list="types" 
			:activeId="typeId"
			@onClick="handleSideTypeClick"
		></side-types>
		<!-- 类型 end -->
		
		<div class="scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">文章标题：</span>
					<el-input v-model="search_title" class="b_inp" placeholder="商户姓名"></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">发布人：</span>
					<el-select v-model="search_publisher" filterable class="b_inp" placeholder="请选择" :clearable="true">
						<el-option v-for="v in appArticlePublisher" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startDate"
						:editable="false"
						placeholder="开始时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchStartDateChange"
					>
					</el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endDate"
						:editable="false"
						placeholder="结束时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchEndDateChange"
					>
					</el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">类型：</span>
					<el-select v-model="search_category" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option v-for="v in appArticleCategory" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增文章</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="id"
						label="序号"
					>
					</el-table-column>
					<el-table-column
						prop="title"
						label="文章标题"
					>
					</el-table-column>
					<el-table-column
						prop="typeName"
						label="分类"
					>
					</el-table-column>
					<el-table-column
						prop="categoryName"
						label="类型"
					>
					</el-table-column>
					<el-table-column
						prop="time"
						label="时间"
					>
					</el-table-column>
					<el-table-column
						prop="publisher"
						label="发布人"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleViewClick(scope.row)"
							>查看</el-button>
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增文章 -->
		<add 
			v-model="add_display"
			:types="types"
			:typeId="typeId"
			:diseaseAndGoods="diseaseAndGoods"
			@onSuccess="addSuccess"
		></add>
		<!-- 新增文章 end -->
		
		<!-- 查看文章 -->
		<view-article 
			v-model="view_display" 
			:types="types" 
			:obj="view_data"
		></view-article>
		<!-- 查看文章 end -->
		
		<!-- 修改文章 -->
		<update 
			v-model="update_display" 
			:types="types" 
			:obj="update_data"
			:diseaseAndGoods="diseaseAndGoods"
			@onSuccess="updateSuccess"
		></update>
		<!-- 修改文章 end -->
	</div>
</template>

<script>
	import SideTypes from './components/side_types.vue';
	import { mapState } from 'vuex';
	import Add from './components/add.vue';
	import ViewArticle from './components/view.vue';
	import Update from './components/update.vue';
	import Api from '../../../../../../api/index.js';
	
	export default{
		mounted() {
			this.findAppDiseaseAndGoods();
		},
		data() {
			return{
				loading: false,
				diseaseAndGoods: [],
				search_title: '',
				search_publisher: '',
				search_startDate: '',
				search_endDate: '',
				search_category: '',
				
				tableData: [],
				total: 0,
				currentPage: 1,
				
				types: [],
				typeId: -1,
				
				add_display: false,
				
				view_display: false,
				view_data: {},
				
				update_display: false,
				update_data: {}
			}
		},
		computed: {
			...mapState([
				'appArticlePublisher',
				'appArticleCategory'
			])
		},
		methods: {
			/******************** @Events *************************/
			// 点击文章分类
			handleSideTypeClick(id) {
				if (this.typeId != id) {
					this.typeId = id;
					this.currentPage = 1;
					this.findArticles();
				}
			},
			// 开始时间
			handleSearchStartDateChange() {
				this.compareSearchDate();
			},
			// 结束时间
			handleSearchEndDateChange() {
				this.compareSearchDate();
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.findArticles();
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.findArticles();
				}
			},
			// 点击新增
			handleAddClick() {
				this.add_display = true;
			},
			// 点击查看
			handleViewClick(data) {
				this.view_data = {...data};
				this.view_display = true;
			},
			// 点击修改
			handleUpdateClick(data) {
				this.update_data = {...data};
				this.update_display = true;
			},
			// 点击删除
			handleDeleteClick(obj) {
				const that = this;
				that.$confirm(
					'此操作将删除该文章，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteArticle(obj.id);
					}
				).catch(
					() => {}
				);
			},
			/******************** @Function *************************/
			// 获取疾病关联商品
			findAppDiseaseAndGoods() {
				const that = this;
				that.loading = true;
				Api.findAppDiseaseAndGoods().then((res) => {
					if (res.data.success) {
						let list = [];
						let diseaseIds = [];
						res.data.data.forEach(v => {
							let isHas = diseaseIds.indexOf(v.diseaseId) == -1 ? false : true;
							if (isHas) {
								list.forEach(vv => {
									if (vv.id == v.diseaseId) {
										vv.goods.push({
											id: v.goodsId,
											name: v.goodsName
										});
									}
								});
							} else {
								list.push({
									id: v.diseaseId,
									name: v.diseaseName,
									goods: [{
										id: v.goodsId,
										name: v.goodsName
									}]
								});
								diseaseIds.push(v.diseaseId);
							}
						});
						that.diseaseAndGoods = list;
						that.findTypes();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取所有文章类型
			findTypes() {
				const that = this;
				Api.findAppArticleTypes().then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.forEach(v => {
							list.push({
								id: v.id,
								name: v.catName,
								time: v.createTs
							});
						});
						that.types = list;
						that.typeId = that.types.length ? that.types[0].id : -1;
						(that.typeId != -1) && that.findArticles();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取文章列表
			findArticles() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					postTitle: that.search_title,
					catId: that.typeId,
					bUserId: that.search_publisher,
					postTag: that.search_category,
					start: that.search_startDate,
					end: that.search_endDate
				};
				Api.findAppArticles(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.records.forEach(v => {
							list.push({
								id: v.id,
								title: v.postTitle,
								subTitle: v.postSummaryContent,
								post: v.postImg,
								typeId: v.catId,
								typeName: that.mapTypeIdToName(v.catId),
								categoryId: v.postTag,
								categoryName: that.mapCategoryIdToName(v.postTag),
								time: v.createTs,
								publisher: v.buserName,
								content: v.postContent
							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 新增成功
			addSuccess() {
				this.findArticles();
			},
			// 修改成功
			updateSuccess() {
				this.findArticles();
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				if (this.search_startDate && this.search_endDate) {
					var startTime = new Date(this.search_startDate).getTime(),
						endTime = new Date(this.search_endDate).getTime();
					if (endTime < startTime) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间！');
					}
				}
			},
			// 把分类id转为名称
			mapTypeIdToName(id) {
				let name = '';
				this.types.forEach(v => {
					v.id == id && (name = v.name);
				});
				return name;
			},
			// 把类型id转为名称
			mapCategoryIdToName(id) {
				let name = '';
				this.appArticleCategory.forEach(v => {
					v.id == id && (name = v.name);
				});
				return name;
			},
			// 删除文章
			deleteArticle(id) {
				const that = this;
				that.loading = true;
				Api.deleteAppArticle(id).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.findArticles();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		components: {
			SideTypes,
			Add,
			ViewArticle,
			Update
		}
	}
</script>

<style scoped>
	.app_article{ position: relative;width: 100%;height: 100%;padding: 0 0 0 150px;overflow: hidden; }
	.app_article .scroller{ width: 100%;height: 100%;padding: 15px;background: #fff;overflow-x: hidden;overflow-y: auto; }
</style>
